import { useState } from "react";
import { Box, Typography } from "@mui/material";
import AssignTaskForm from "./AssignTaskForm";
import ManualTaskAssignmentReport from "./ManualTaskAssignmentReport";

export default function ClioMatterInteraction() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
        Clio Task Assignments
      </Typography>
      <AssignTaskForm onAssigned={() => setRefreshKey((key) => key + 1)} />
      <ManualTaskAssignmentReport refreshKey={refreshKey} />
    </Box>
  );
}
